import { Col, Row, Typography } from 'antd';
import jwt from 'jsonwebtoken';
import PropTypes from 'prop-types';
import React from 'react';
import { JobCardComponent } from '../';
import { STATUS, COMPARE_STATUS, IS_VETTING_USEABLE } from '../../../constants/status';
import JOB_ACTION_CARD_CONSTANT from '../constants/jobconstants';
import JobNavigation from '../JobNavigation/JobNavigation';
import './index.css';

const userToken = localStorage.getItem('token');

const JobEligibilitySection = ({ current_status = '', jobEligibility, jobs = [], bookedTIDate = null, onConsiderMe, total = 0, page = 1, loadJobs }) => {
  let user_id = '';
  if (userToken && userToken !== '') {
    const user = jwt.decode(userToken);
    user_id = parseFloat(user.uid);
  }

  /* JOB STATUS: RANK CHECK MUST BE FROM HIGHER TO LOWEST */
  const job_status = [
    { state: 'PASSED_TI_ADDITIONAL_CHECK_BY_JOB', check: COMPARE_STATUS(current_status, STATUS.PASSED_TI) && IS_VETTING_USEABLE(current_status) ? 1 : -1 },
    { state: JOB_ACTION_CARD_CONSTANT.BOOKEDTI_FUTUREDATE, check: COMPARE_STATUS(current_status, STATUS.TECHNICAL_INTERVIEW) && IS_VETTING_USEABLE(current_status) ? 1 : -1 },
    { state: JOB_ACTION_CARD_CONSTANT.PASSEDTEST_NOTBOOKTI, check: COMPARE_STATUS(current_status, STATUS.SCHEDULING_TECH_INTERVIEW) && IS_VETTING_USEABLE(current_status) ? 1 : -1 },
    { state: JOB_ACTION_CARD_CONSTANT.BOOKEDTI_FAILED, check: COMPARE_STATUS(current_status, STATUS.FAILED) === 0 || !IS_VETTING_USEABLE(current_status) ? 1 : -1 }, /* ONLY CHECK = 1 IF CANDIDATE'S STATUS === FAIL, BECAUSE FAIL IS AT THE LOWEST INDEX */
    { state: JOB_ACTION_CARD_CONSTANT.DEFAULT, check: 1 }
  ].find(e => e.check >= 0).state;

  return (
    <div className="JobEligibilitySection">
      <JobNavigation total={total} page={page} onClick={loadJobs}>
        <Row>
          <Col style={{ marginBottom: '12px' }}>
            {
              jobEligibility === JOB_ACTION_CARD_CONSTANT.ELIGIBLE
                ? <Typography.Text className="title-area">Eligible for</Typography.Text>
                : <Typography.Text className="title-area">Almost eligible for</Typography.Text>
            }
          </Col>
          <Col style={{ marginBottom: '36px' }}>
            {
              jobEligibility === JOB_ACTION_CARD_CONSTANT.ELIGIBLE
                ? <Typography.Text className="title-description">You are eligible for {total} job{total > 1 ? 's' : ''}</Typography.Text>
                : <Typography.Text className="title-description">You are almost eligible for {total} job{total > 1 ? 's' : ''}. Become eligible by passing the Live Coding Challenge.</Typography.Text>
            }
          </Col>
        </Row>
      </JobNavigation>
      <Row type="flex" gutter={[16, 16]}>
        {
          jobs.map((job) => {
            const selfPicked = job.selectedUsers && Array.isArray(job.selectedUsers) && job.selectedUsers.length > 0 && job.selectedUsers.indexOf(user_id) >= 0;
            const anotherPicked = job.selectedUsers && Array.isArray(job.selectedUsers) && job.selectedUsers.length > 0 && job.selectedUsers.indexOf(user_id) < 0;
            /* const considered = job.matchedUsers && job.selectedUsers && Array.isArray(job.selectedUsers) && job.selectedUsers.length === 0 &&
              Array.isArray(job.matchedUsers) && job.matchedUsers.indexOf(user_id) >= 0 */
            /* ISSUE HERE: CANDIDATE APPLY, THAT MEAN HE WAS CONSIDERED FOR THE JOB
            OR: WHEN VETOPS ADD THE CANDIDATE TO THE MATCHING USERS LIST?
            PING CK FOR ANSWER, CURRENTLY USE considerMe, THAT MEAN WHEN CANDIDATE APPLY */
            const considered = job.considerMe || false;

            if (job_status !== 'PASSED_TI_ADDITIONAL_CHECK_BY_JOB') {
              return <Col key={job.id}>
                <JobCardComponent
                  onConsiderMe={onConsiderMe}
                  job={job}
                  future_date={bookedTIDate}
                  job_status={job_status}
                />
              </Col>;
            }

            return <Col key={job.id}>
              <JobCardComponent
                onConsiderMe={onConsiderMe}
                job={job}
                future_date={bookedTIDate}
                picked_date={job.picked_date}
                job_status={ selfPicked
                  ? JOB_ACTION_CARD_CONSTANT.SELF_PICKED
                  : (anotherPicked
                    ? JOB_ACTION_CARD_CONSTANT.ANOTHER_PICKED
                    : (considered
                      ? JOB_ACTION_CARD_CONSTANT.CONSIDERED
                      : JOB_ACTION_CARD_CONSTANT.BOOKEDTI_PASSED
                    )
                  )
                }
              />
            </Col>;
          })
        }
      </Row>
    </div>
  );
};

JobEligibilitySection.propTypes = {
  current_status: PropTypes.string,
  jobEligibility: PropTypes.string,
  jobs: PropTypes.array,
  bookedTIDate: PropTypes.string,
  loadJobs: PropTypes.func,
  page: PropTypes.number,
  total: PropTypes.number,
  onConsiderMe: PropTypes.func
};

export default JobEligibilitySection;
